export const AUDIENCE = {
  ADMIN: "ADMIN",
  SCHOOL: "SCHOOL",
  CUSTOMER: "CUSTOMER",
} as const;

export type Audience = (typeof AUDIENCE)[keyof typeof AUDIENCE];
